import { render, staticRenderFns } from "./ContactFlmBlock.vue?vue&type=template&id=db4d13d8"
import script from "./contactFlmBlock.ts?vue&type=script&lang=js&external"
export * from "./contactFlmBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports